import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/node_modules/next/font/google/target.css?{\"path\":\"src/app/language_layout.tsx\",\"import\":\"Space_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/app.webp");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/avalanche.webp");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/base.webp");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/benefi1.webp");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/benefit2.webp");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/Binance.webp");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/Ethereum-Landscape-Black-Logo.wine.webp");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/public/img/polygon.webp");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/src/components/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalVideo"] */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/src/components/LocalVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/Users/frandeniaruiz/Documents/Development/landingcryptobuilder.io/nextly-template/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/Users/frandeniaruiz/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
